// extracted by mini-css-extract-plugin
export default {"not-found-content":"TBody_not-found-content__K7e2i"};